/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Center_LeftInputs */

const en_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center Left`)
};

const fr_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre Gauche`)
};

const de_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte links`)
};

const it_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro sinistra`)
};

const ru_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центр слева`)
};

const es_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro Izquierda`)
};

const zh_cn2_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左中`)
};

const ja_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央左`)
};

const hi_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र बाएँ`)
};

const pt_pt2_input_position_center_left = /** @type {(inputs: Input_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro Esquerdo`)
};

/**
* | output |
* | --- |
* | "Center Left" |
*
* @param {Input_Position_Center_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_center_left = /** @type {((inputs?: Input_Position_Center_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Center_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_center_left(inputs)
	if (locale === "de") return de_input_position_center_left(inputs)
	if (locale === "it") return it_input_position_center_left(inputs)
	if (locale === "ru") return ru_input_position_center_left(inputs)
	if (locale === "es") return es_input_position_center_left(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_center_left(inputs)
	if (locale === "ja") return ja_input_position_center_left(inputs)
	if (locale === "hi") return hi_input_position_center_left(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_center_left(inputs)
	return en_input_position_center_left(inputs)
});